import {
  Button,
  FormControl,
  Grid,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@material-ui/core";
import withAdminLayout from "components/HoC/withAdminLayout";
import { useFormik } from "formik";
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import * as yup from "yup";
import clsx from 'clsx';
import { DatePicker } from "@material-ui/pickers";
import { get } from "lodash";
import DatetimeService from "services/DatetimeService";
import { isError } from "libs/utils/form";
import { StyledTableCell } from "components/request-document/components/Commons";
import { StyledTableRow } from "components/common/Table";
import InputLabel from '@material-ui/core/InputLabel';
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { format } from "date-fns";
import ReportService from "services/ReportService";
import mime from 'mime';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  wrapHeader: {
    padding: "3px 10px", borderRadius: "5px", height: "45px", alignItems: "center", display: "flex", color: "gray"
  },
  border1: {
    border: '1px solid rgba(0,0,0,.125)'
  },
  wrapHeaderRight: {
    display: "flex",
    width: '100%',
    justifyContent: 'space-between'
  },
  formControl: {
    padding: "5px",
    width: '100%',
    marginTop: 5
  },
  wrapFilter: {
    height: '100%',
    padding: 0,
    paddingTop: 15
  },
  tableHead: {
    color: "black", backgroundColor: "white", fontWeight: "500", width: "1%", whiteSpace: "nowrap"
  },
  tableCell: {
    backgroundColor: 'white',
    borderBottom: "1px solid rgba(224, 224, 224, 0.5)",
    width: "1%", whiteSpace: "nowrap"
  },
  p0: {
    padding: 0
  }
}));

function createData(date, docNo, firstName, lastName, email, tel, visaType, status, staff) {

  return { date, docNo, firstName, lastName, email, tel, visaType, status, staff };
}
function ReportVisaTypePage() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const masterData = useSelector(selectMasterData);
  const smartservices = get(masterData, "smartservice", []);

  const [Data, setData] = useState([]);



  const reports = [
    // {
    //   name: 'reportTypeIndustry',
    //   text: 'รายงานคำขอ (ประเภทอุตสาหกรรม)'
    // },
    {
      name: 'reportTypeVisa',
      text: 'รายงานคำขอ (ประเภทคำขอ)'
    },

    {
      name: 'reportKPI',
      text: 'รายงาน KPI'
    }
  ]

  useEffect(() => {


    async function mergedFetchData() {
      await dispatch(
        getMasterData({
          smartservice: true,
        })
      );

      // await fetchData();
    }
    mergedFetchData();


  }, [dispatch]);


  const validationSchema = yup.object({
    // ContactEmail: yup.string().email("Invalid email format"),
  });

  const flDate = DatetimeService.getFirstAndLastDayOfYear(new Date());

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      reportType: 'reportTypeVisa',
      startDate: flDate.firstDate,
      endDate: flDate.lastDate,
      smartService: null
    },
    onSubmit: async (values) => {
      await fetchData();
    },
  });

  const resetForm = () => {
    formik.resetForm();
  }


  const getParams = () => {
    const body = {
      startDate: formik.values?.startDate ? format(new Date(formik.values?.startDate), "yyyy-MM-dd") : null,
      endDate: formik.values?.endDate ? format(new Date(formik.values?.endDate), "yyyy-MM-dd") : null,
      smartserviceId: formik.values.smartService,
    }
    return body;
  }

  const fetchData = async () => {
    setData([]);
    const body = getParams();
    const res = await ReportService.getReportDataVisaType(body);
    console.log(res.results);
    if (res.status) {
      setData(res.results);
    }

  }

  const downloadReport = async () => {
    const body = getParams();
    const blob = await ReportService.getReportExcelVisaType(body)
    const blobFile = new File([blob], 'Report Visa Type.xlsx', {
      type: mime.getType('.xlsx'),
    });

    window.open(
      URL.createObjectURL(blobFile, 'Report Visa Type.xlsx'),
      "_blank"
    );
  }



  console.log(Data);
  return (
    <Paper className={classes.paper}>
      <form onSubmit={formik.handleSubmit} id="report-industy" name="report-industy">
        <div className={classes.wrapForm}>
          <Grid container spacing={0}>
            <Grid item xs={12} lg={2}>
              <div className={clsx(classes.wrapHeader, classes.border1)}>
                Filter
              </div>
            </Grid >

            <Grid item xs={12} lg={10}>
              <div className={clsx(classes.wrapHeader, classes.border1, classes.wrapHeaderRight)}>
                <div >
                  รายงานคำขอ (ประเภทคำขอ)
                </div>
                <Button variant="outlined" size="medium" color="primary" className={classes.buttonSave}
                  onClick={() => downloadReport()}>
                  Download
                </Button>
              </div>

            </Grid >
          </Grid >
          <Grid container spacing={0}>
            <Grid item xs={12} lg={2}>
              <div className={clsx(classes.border1, classes.wrapFilter)}>
                <div>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <Select
                      // className={classes.formControl}
                      value={
                        get(formik.values, `reportType`, null) ||
                        null
                      }
                      name="reportType"
                      onChange={(event) => {
                        const reportType = event.target.value;

                        if (reportType === 'reportTypeIndustry') {
                          history.push(`/admin/report/industry`);
                        }

                        if (reportType === 'reportTypeVisa') {
                          history.push(`/admin/report/visaType`);
                        }

                        if (reportType === 'reportKPI') {
                          history.push(`/admin/report/kpi`);
                        }


                        formik.setFieldValue("reportType", event.target.value);
                      }}
                    >
                      {reports.map((config) => (
                        <MenuItem
                          key={config.name}
                          value={config.name}
                        >
                          {config.text}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div>
                  <FormControl variant="outlined" className={clsx(classes.formControl, classes.p0)}>
                    <DatePicker
                      className={classes.formControl}
                      inputVariant="outlined"
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="Start Date"
                      views={["year", "month", "date"]}
                      name={`startDate`}
                      value={
                        get(formik.values, `startDate`, null) ||
                        null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          `startDate`,
                          date.format("YYYY-MM-DD")
                        );
                      }}
                      error={isError("startDate", formik)}
                    />
                  </FormControl>
                </div>
                <div>
                  <FormControl variant="outlined" className={clsx(classes.formControl, classes.p0)}>
                    <DatePicker
                      className={classes.formControl}
                      inputVariant="outlined"
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="End Date"
                      views={["year", "month", "date"]}
                      name={`endDate`}
                      value={
                        get(formik.values, `endDate`, null) ||
                        null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          `endDate`,
                          date.format("YYYY-MM-DD")
                        );
                      }}
                      error={isError("endDate", formik)}
                    />
                  </FormControl>
                </div>
                <div>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">Visa Type</InputLabel>
                    <Select
                      // className={classes.formControl}
                      name="smartService"
                      label="Visa Type"
                      value={formik.values.smartService}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <MenuItem value={null}>
                        All
                      </MenuItem>

                      {
                        smartservices.map(a => (

                          <MenuItem
                            key={a.smartserviceId}
                            value={a.smartserviceId}>
                            {a.smartserviceName}
                          </MenuItem>

                        ))
                      }

                    </Select>
                  </FormControl>
                </div>
                <div className={classes.formControl} style={{ textAlign: 'right' }}>
                  <Button variant="contained" size="medium" color="primary" className={classes.buttonSave} type="submit" >
                    Search
                  </Button>
                </div>

              </div>

            </Grid >


            <Grid item xs={12} lg={10}>
              <div className={clsx(classes.border1, classes.wrapFilter)} style={{ padding: 15 }}>
                <TableContainer component={Paper} style={{ borderRadius: 0, maxHeight: '75vh' }}>
                  <Table stickyHeader className={classes.table} size="small" aria-label="a dense table">
                    <TableHead>
                      <StyledTableRow>
                        <TableCell className={classes.tableHead}>Date</TableCell>
                        <TableCell className={classes.tableHead} >Doc No.</TableCell>
                        <TableCell className={classes.tableHead} >First Name</TableCell>
                        <TableCell className={classes.tableHead} >Last Name</TableCell>
                        <TableCell className={classes.tableHead} >Email</TableCell>
                        <TableCell className={classes.tableHead} >Visa Type</TableCell>
                        <TableCell className={classes.tableHead} >Status</TableCell>
                        <TableCell className={classes.tableHead} >Staff</TableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {Data.map((row) => (
                        <StyledTableRow key={row.draftId}>
                          <TableCell className={classes.tableCell} component="th" scope="row">
                            {format(new Date(row.createDate), "yyyy-MM-dd")}
                          </TableCell>
                          <TableCell className={classes.tableCell} >{row.docNo}</TableCell>
                          <TableCell className={classes.tableCell} >{row.personalFirstName}</TableCell>
                          <TableCell className={classes.tableCell} >{row.personalLastName}</TableCell>
                          <TableCell className={classes.tableCell} >{row.personalEmail}</TableCell>
                          <TableCell className={classes.tableCell} >{row.visaType}</TableCell>
                          <TableCell className={classes.tableCell} >{row.docStatus}</TableCell>
                          <TableCell className={classes.tableCell} >{row.staffFirstName} {row.staffLastName}</TableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </Grid >
          </Grid >
        </div >
      </form >
    </Paper >
  );
}

export default withAdminLayout(ReportVisaTypePage);

